module.exports = function (fox) {
	'use strict';
	
	return function (contentRow) {
		var obj;
		var $ = fox.jQuery;
		var wide = $(window).width() > 600;
		
		var leftCol = document.createElement('div');
		var rightCol = document.createElement('div');

		this.fragment = this.createFragment();

		this.dl.resetIterator('mix');

		while ((obj = this.dl.iterateObject('mix'))) {
			var tplRow = this.getOption('tpl.' + (
				fox.isObject(contentRow) ? contentRow[obj.get('type')] : 'row'
			));

			var row = this.getTemplater(tplRow).setData([obj]).compile();

			if (wide) {
				var res = obj._pointer % 2 === 0 ? leftCol.appendChild(row) : rightCol.appendChild(row);
			} else {
				this.fragment.appendChild(row);
			}
		}

		if (wide) {
			this.fragment.appendChild(leftCol);
			this.fragment.appendChild(rightCol);

			return true;
		}

		return true;
	};
};


//////////////////
// WEBPACK FOOTER
// ./mixins/listRender.js
// module id = 38
// module chunks = 4